module.exports = __webpack_public_path__ + "static/media/Fraxure_gaussian2.478f2ce9.png";